const AUTH = {
  UN_AUTHORIZE: "UN_AUTHORIZE",
};

export default AUTH;